import { AppContext } from "@/services/AppContext/appContext";
import { Button } from "@/shadcn/components/ui/button";
import {
  Command,
  CommandEmpty,
  CommandGroup,
  CommandInput,
  CommandItem,
  CommandList,
} from "@/shadcn/components/ui/command";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/shadcn/components/ui/popover";
import { ScrollArea } from "@/shadcn/components/ui/scroll-area";
import { Check, ChevronsUpDown, ListFilter } from "lucide-react";
import React, { useContext } from "react";

type InboxFiltersProps = {
  selectedSenders: number[];
  setSelectedSenders: (ids: number[]) => void;
};

const InboxFilters: React.FC<InboxFiltersProps> = ({
  selectedSenders,
  setSelectedSenders,
}) => {
  const { allAppUsers } = useContext(AppContext);

  const handleMouseDown = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
  };

  function handleFieldSenders(id: number) {
    if (selectedSenders.includes(id)) {
      setSelectedSenders(selectedSenders.filter((c) => c !== id));
    } else {
      setSelectedSenders([...selectedSenders, id]);
    }
  }

  function clearFilters() {
    setSelectedSenders([]);
  }

  return (
    <div className="flex content-center items-center gap-3">
      <div>
        <ListFilter className="w-5 h-5" />
      </div>
      <Popover>
        <PopoverTrigger
          className="w-full"
          onMouseDown={(e) => {
            e.stopPropagation();
            e.preventDefault();
          }}
          onClick={(e) => {
            e.stopPropagation();
          }}
          asChild
        >
          <Button
            id="edit-selectedSenders"
            variant="outline"
            role="combobox"
            className="justify-between w-full"
            onMouseDown={handleMouseDown}
          >
            {selectedSenders && selectedSenders.length > 0
              ? `${selectedSenders.length} selected`
              : "Select Users"}
            <ChevronsUpDown className="ml-2 h-4 w-4 shrink-0 opacity-50" />
          </Button>
        </PopoverTrigger>
        <PopoverContent
          className="w-full p-0"
          onMouseDown={(e) => {
            e.stopPropagation();
            e.preventDefault();
          }}
          onClick={(e) => {
            e.stopPropagation();
          }}
        >
          <Command>
            <CommandInput placeholder="Search Selected Senders..." />
            <CommandList>
              <ScrollArea className="h-[200px]">
                <CommandEmpty>No Selected Senders Found.</CommandEmpty>
                <CommandGroup>
                  {allAppUsers.map((user) => (
                    <CommandItem
                      key={user.id}
                      onSelect={() => handleFieldSenders(user.id)}
                      onMouseDown={handleMouseDown}
                    >
                      <Check
                        className={`mr-2 h-4 w-4 ${
                          selectedSenders?.some((c) => c === user.id)
                            ? "opacity-100"
                            : "opacity-0"
                        }`}
                      />
                      {user.first_name} {user.surname}
                    </CommandItem>
                  ))}
                </CommandGroup>
              </ScrollArea>
            </CommandList>
          </Command>
        </PopoverContent>
      </Popover>
      <Button
        variant={"outline"}
        className={`items-center justify-center `}
        onClick={clearFilters}
      >
        Clear Filters
      </Button>
    </div>
  );
};

export default InboxFilters;
